import React from "react";
import { useChat } from "../context/ChatContext";
import "../styles/chat.css";

const MessageList = () => {
  const { messages } = useChat();

  const formatMessage = (text: string) => {
    // Check if message contains code (multiple lines or indentation)
    const hasNewlines = text.includes("\n");
    if (hasNewlines) {
      return (
        <pre className="message-code">
          <code>{text}</code>
        </pre>
      );
    }
    // Regular message with line break preservation
    return <p className="message-text" style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>{text}</p>;
  };

  return (
    <div className="message-list">
      {messages.map((msg, index) => (
        <div key={index} className="message">
          <strong>{msg.user}: </strong>
          {formatMessage(msg.text)}
          <div className="timestamp">{msg.timestamp}</div>
        </div>
      ))}
    </div>
  );
};

export default MessageList;
